// Libraries
import React from 'react';

// App
import FieldInput from '@shared/design/components/Field/FieldInput';
import MultiDropdownCheckboxInput from '@shared/design/components/Field/MultiDropdownCheckboxInput';

const SalespersonCalendarSelect = ({
  selectedSalesPersonIds,
  salespersonOptions,
  handleSalesPersonIdsChange,
}: {
  selectedSalesPersonIds: number[];
  salespersonOptions: {
    value: number | null;
    label: string;
    description: string;
  }[];
  handleSalesPersonIdsChange: (salesPersonIds: number[]) => void;
}) => {
  return (
    <FieldInput
      index={0}
      label={'Calendars'}
      name={'selectedOptions'}
      component={MultiDropdownCheckboxInput}
      input={{
        options: salespersonOptions,
        value: selectedSalesPersonIds,
        placeholder: `Select calendar(s)`,
        isResponsive: true,
        usePills: true,
        isEnabledSelectAll: true,
        onSelectAll: () => {
          if (selectedSalesPersonIds.length > 0) {
            handleSalesPersonIdsChange([]);
          } else {
            const allSalespersonIds = salespersonOptions
              .filter((option) => option.value !== null)
              .map((option) => option.value) as number[];
            handleSalesPersonIdsChange(allSalespersonIds);
          }
        },
        onChangeValue: (selectedIds: number[]) => {
          handleSalesPersonIdsChange(selectedIds);
        },
      }}
    />
  );
};

export default SalespersonCalendarSelect;
